import { Link } from "react-router-dom";
import BioBlock from "../BioBlock/BioBlock";

const ShortBio = () => {
  return (
    <div>
      <h2 className="text-4xl font-bold">Lauri Mattila, Helsinki</h2>

      <BioBlock
        header="Musiikkikoordinaattori"
        link="https://www.verkosto.net/"
        linkText="Verkosto seurakuntayhteisö"
      />
      <BioBlock
        header="Musiikkiterapiaopiskelija"
        link="https://www.roihainstituutti.fi/taideterapiakoulutukset/musiikkiterapia/"
        linkText="Eino Roiha Instituutti (Jyväskylä)"
      />
      <BioBlock
        header="Näyttelijä"
        link="https://kansanraamattuseura.fi/osallistu-tai-tilaa/teatteri/raamattukyla/"
        linkText="Vivamon Raamattukylä (Lohja, vapaaehtoistyö)"
      />

      <p className="mt-16">
        Jos haluat tietää tarkemmin mun matkasta tähän pisteeseen ja siitä,
        et oon julkasemassa albumin verran kristillistä musiikkia,
        niin kurkkaa ihmeessä <Link to="/bio">Biographyn</Link> alle!
      </p>

    </div>
  )
};

export default ShortBio;